<template>
  <div class="flex items-stretch items-baseline gap-x-2 w-full">

    <div class="flex w-full panel">
      <upload-pictogram v-if="!parserDxf"
        @epc-pictogram-design="(design) => { file = design.inputFile, parserDxf = design.parserDxf }"
      ></upload-pictogram>

      <div class="flex items-center w-full" v-if="parserDxf != null && scene == null">
        <div class="" style="width: 480px; padding: 30px 0 8px; margin: 0 auto; color: #0a131c">
          <h3 class="font-light text-center text-4xl">Archivo cargado {{  file.name }}</h3>
          <p class="text-center text-sm mt-2.5 mx-0 mb-9">Complete el formulario para generar correctamente el diseño.</p>
          <div class="text-center mt-6" style="color: #76767D">
            <b-icon icon="file" pack="fas" custom-size="fa-5x"></b-icon>
          </div>
        </div>
      </div>

      <ViewerPageKonva v-if="scene != null"
        ref="refViewerPageKonva"
        :canActionsPictogram="_canActionsPictogram"
        :pictogram="scene"
        :work-layer="workLayer"
        @epc-reload="() => { $emit('epc-reload') }"></ViewerPageKonva>

    </div>
    <div v-if="parserDxf"
      class="w-5/12 flex panel">
      <data-pictogram v-if="null == scene"
        :dxf="parserDxf"
        @epc-pictogram-preview="_HandlePictogramPreview"
        @epc-pictogram-data-close="() => { _Reset() }">
      </data-pictogram>

      <save-pictogram v-if="null != scene"
        ref="refSavePictogram"
        :entity-id="projectId"
        :input-file="file"
        :parse-dxf="parserDxf"
        :data="dataPictogram"
        @epc-pictogram-save="_HandlePictogramSave"
        @epc-pictograms-reload="_HandlePictogramsReload"
        @epc-pictogram-save-close="() => { _Reset() }"
        @epc-pictogram-show-loader="_HandleShowLoader">
      </save-pictogram>
    </div>
  </div>
</template>

<script>
import UploadPictogram from './components/upload-pictogram.vue'
import DataPictogram from './components/data-pictogram.vue'
import SavePictogram from './components/save-pictogram.vue'
import ViewerPageKonva from './viewer-konva/ViewerPageKonva.vue'

export default {
  name: "manage-pictogram-add",

  components: {
    ViewerPageKonva,
    UploadPictogram,
    DataPictogram,
    SavePictogram
  },

  props: {
    projectId: { type: Number, required: true },
    canActionsPictogram: { type:Object, default() { return {} } }, // acciones que se puede realizar sobre el pictograma por defecto ninguna
    permittedActions: { type:Object, default() { return {} } } // acciones que se mostraran en la columna acciones por defecto todas
  },

  data() {
    return {
      file: null, // Archivo dxf subido que contiene el diseño CAD
      parserDxf: null, // Objeto que contiene el dxf parseado
      scene: null, // Objeto que contiene la escena para ser visualizada por el viewer konva
      dataPictogram: null, // Objeto que contiene datos del pictograma
      workLayer: null, // capa donde  trabajará el usuario, solo permite trabajar en esa capa si null trabaja en todas
      _canActionsPictogram: this.canActionsPictogram
    }
  },

  computed: {
  },

  created() {

  },

  mounted() {

  },

  destroyed() {

  },

  beforeDestroy() {

  },

  methods: {
    _HandlePictogramPreview(data) {
      // Desactivamos todas las acciones por que solo se visualizará el diseño
      this._canActionsPictogram = {
        'save': false,
        'select_entity': false
      }

      this.scene = {
        preview: true,
        scene: data.scene,
        layers: data.layers.filter((el) => { return el.create_entities })
      }

      this.dataPictogram = data
    },

    _Reset() {
      this.parserDxf = null
      this.file = null;
      this.scene = null;
      this.dataPictogram = null
    },

    async _HandlePictogramSave() {
      this._HandleShowLoader({ loading: true, text: "Generando imagenes" })

      this.$refs.refViewerPageKonva.ShowPanelScreenshot(true)
      // 1.- Obtenemos las capturas de las diferentes capas (screenshot en formato png)
      let screenshots = await this.$refs.refViewerPageKonva.GetScreenshotsLayers()

      this.$refs.refViewerPageKonva.ShowPanelScreenshot(false)
      // 2.- Guardamos los datos del pictograma
      this.$refs.refSavePictogram.SaveDataPictogram(screenshots)
    },

    _HandleShowLoader(data) {
      this.$refs.refViewerPageKonva.ShowLoader(data)
    },

    _HandlePictogramsReload() {
      this.$emit('epc-pictograms-reload')
    },
  }

};
</script>

<style scoped>

</style>
